const isMac = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}

const isWindows = () => {
  return /windows|win32/i.test(navigator.userAgent)
}

let CryptoAgent = {}

if (isWindows()) {
  try {
    const eDiv = document.createElement('div')
    eDiv.style.height = 0
    if (navigator.appName.indexOf('Internet') >= 0 || navigator.appVersion.indexOf('Trident') >= 0) {
      if (window.navigator.cpuClass == 'x86') {
        eDiv.innerHTML =
          '<object id=\"CryptoAgent\" codebase=\"CryptoKit.HSXXJS.x86.cab\" classid=\"clsid:A15EACD9-43A5-43F6-A010-CD13207B7723\" ></object>'
      } else {
        eDiv.innerHTML =
          '<object id=\"CryptoAgent\" codebase=\"CryptoKit.HSXXJS.x64.cab\" classid=\"clsid:800267BD-C277-43CF-914E-E416AD864D4D\" ></object>'
      }
    } else {
      eDiv.innerHTML =
        '<embed id=\"CryptoAgent\" type=\"application/npCryptoKit.HSXXJS.x86\" style=\"height: 0px; width: 0px\">'
    }
    document.body.appendChild(eDiv)
  } catch (e) {
    console.log('e-----', e)
  }
  CryptoAgent = document.getElementById('CryptoAgent')
}

if (isMac()) {
  //TODO  mac待处理
}

const cgbUkey = {}

/*
BSTR bstrSubjectDNFilter: [IN]目标证书主题 DN 中所包含的字符串。
BSTR bstrIssuerDNFilter: [IN]目标证书颁发者 DN 中所包含的字符串。
BSTR bstrSerialNumFilter: [IN]目标证书的序列号，作为该筛选条件选出证书。
BSTR bstrCSPNameList:[IN]证书的 CSP 列表，以“||”隔开。（选 SM2 证书，此参数不能为空）
*/
cgbUkey.selectCertificate = ({ subjectDNFilter = '', issuerDNFilter = '', serialNumFilter = '', cspNameList = '' }) => {
  return new Promise((resolve, reject) => {
    try {
      const bSelectCertResult = CryptoAgent.SelectCertificate(
        subjectDNFilter,
        issuerDNFilter,
        serialNumFilter,
        cspNameList
      )
      if (!bSelectCertResult) {
        reject(getError())
        return
      }
      resolve(bSelectCertResult)
    } catch (ee) {
      reject(getError())
    }
  })
}

/*
sourceHashData: 待签名原文
selectedAlg: hash算法  SHA-1  SHA-256
withSourceData：带原文签名
*/
cgbUkey.signOn = (sourceHashData = '', selectedAlg = 'SHA-1', withSourceData = true) => {
  return new Promise((resolve, reject) => {
    try {
      const sigure = CryptoAgent.SignMsgPKCS7(sourceHashData, selectedAlg, withSourceData)
      if (!sigure) {
        reject(getError())
        return
      }
      resolve(sigure)
    } catch (e) {
      reject(getError())
    }
  })
}

/*
“SubjectDN”: 证书主题 DN；
“SubjectCN”: 证书主题 CN；
“SerialNumber”: 证书序列号；
“IssuerDN”: 颁发者；
“CertType”： 证书类型；
“CSPName”: 证书对应的 CSP 名称；
“CertContent”： 公钥证书的 Base64 编码；
“ValidFrom”：证书有效期起始时间；
“ValidTo”：证书有效期截止时间。
*/
cgbUkey.getSignCertInfo = () => {
  return new Promise((resolve, reject) => {
    try {
      const subjectCN = CryptoAgent.GetSignCertInfo('SubjectCN')
      const serialNumber = CryptoAgent.GetSignCertInfo('SerialNumber') ?? ''
      const validFrom = CryptoAgent.GetSignCertInfo('ValidFrom') ?? ''
      const validTo = CryptoAgent.GetSignCertInfo('ValidTo') ?? ''
      const subjectDNInfo = subjectCN?.split('@')
      const userName = subjectDNInfo?.[1] ?? ''
      const info = {
        userName,
        serialNumber,
        validFrom,
        validTo
      }

      if (!subjectCN) {
        reject(getError())
        return
      }
      resolve(info)
    } catch (e) {
      reject(getError())
    }
  })
}

cgbUkey.driveUrl = () => {
  return 'https://static.ekuaibao.com/public/cryptoKit.zip'
}

function getError() {
  return CryptoAgent.GetLastErrorDesc()
}

global.cgbUkey = cgbUkey
global.isMac = isMac
